import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Container,
  Button,
} from "@mui/material";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { investorApi } from "../../../api/api";

const BASE_URL = "http://localhost/realmart_api/public";

const HomeLegalExperts = () => {
  const [allLegalTeam, setAllLegalTeam] = useState([]);
  const [legalTeam, setLegalTeam] = useState([]);
  const navigate = useNavigate();
  const theme = useSelector((data) => data.themeValue.colors);

  useEffect(() => {
    const fetchLegalTeam = async () => {
      try {
        const response = await investorApi.getLegalTeam();
        if (response.status === 200) {
          const updatedData = response.data.map((item) => ({
            ...item,
            profile_path: item.profile_path.startsWith("http")
              ? item.profile_path
              : `${BASE_URL}/storage/${item.profile_path.replace(
                  "public/storage/",
                  ""
                )}`,
          }));

          setAllLegalTeam(updatedData);           // Full data
          setLegalTeam(updatedData.slice(0, 4));  // Only 4 for home
        }
      } catch (err) {
        console.error(err);
      }
    };

    fetchLegalTeam();
  }, []);

  // ✅ Hide component if no data
  if (allLegalTeam.length === 0) return null;

  // 🔥 Card Component
  const CardItem = ({ member }) => (
    <Box
      sx={{
        height: { xs: 260, sm: 280, md: 320 },
        borderRadius: "16px",
        overflow: "hidden",
        position: "relative",
        cursor: "pointer",
        transition: "0.3s",
        "&:hover": {
          transform: "translateY(-6px)",
          boxShadow: "0 8px 25px rgba(0,0,0,0.2)",
        },
      }}
    >
      {/* Image */}
      <Box
        component="img"
        src={member.profile_path}
        alt={member.name}
        sx={{
          width: "100%",
          height: "100%",
          objectFit: "cover",
        }}
      />

      {/* Overlay */}
      <Box
        sx={{
          position: "absolute",
          bottom: 0,
          width: "100%",
          height: "60%",
          background:
            "linear-gradient(to top, rgba(0,0,0,0.85), transparent)",
        }}
      />

      {/* Text */}
      <Box
        sx={{
          position: "absolute",
          bottom: 0,
          p: 2,
          color: "#fff",
        }}
      >
        <Box fontWeight="bold">{member.name}</Box>
        <Box fontSize="0.85rem" sx={{ opacity: 0.8 }}>
          {member.specialization}
        </Box>
      </Box>

      {/* Badge */}
      <Box
        sx={{
          position: "absolute",
          top: 10,
          left: 10,
          background: "linear-gradient(135deg, #22c55e, #16a34a)",
          color: "#fff",
          px: 1.5,
          py: 0.3,
          borderRadius: "8px",
          fontSize: "0.75rem",
          fontWeight: 600,
        }}
      >
        Expert
      </Box>
    </Box>
  );

  return (
    <Box
      sx={{
        py: { xs: 5, md: 8 },
        background: theme.background,
      }}
    >
      <Container maxWidth="lg" sx={{ px: { xs: 2, sm: 3 } }}>
        {/* Heading */}
        <Box sx={{ textAlign: "center", mb: { xs: 4, md: 6 } }}>
          <Typography
            fontWeight="bold"
            sx={{
              fontSize: { xs: "1.4rem", sm: "1.8rem", md: "2.2rem" },
              background: "linear-gradient(90deg, #19469b, #4f46e5)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
            }}
          >
            Our Legal Experts
          </Typography>

          <Typography
            sx={{
              color: theme.text,
              opacity: 0.7,
              mt: 1,
              fontSize: { xs: "0.9rem", md: "1rem" },
            }}
          >
            Trusted professionals to guide your property journey
          </Typography>
        </Box>

        {/* 🔥 Responsive Grid */}
        <Box
          sx={{
            display: "grid",
            gap: 2,
            gridTemplateColumns: {
              xs: "1fr",
              sm: "repeat(2, 1fr)",
              md: "repeat(3, 1fr)",
              lg: "repeat(4, 1fr)",
            },
          }}
        >
          {legalTeam.map((member) => (
            <CardItem key={member.id} member={member} />
          ))}
        </Box>

        {/* 🔥 Show button only if more than 4 */}
        {allLegalTeam.length > 4 && (
          <Box sx={{ textAlign: "center", mt: { xs: 4, md: 6 } }}>
            <Button
              onClick={() => navigate("/legal-team")}
              sx={{
                px: { xs: 3, md: 5 },
                py: 1.5,
                borderRadius: "30px",
                fontWeight: 600,
                textTransform: "none",
                fontSize: { xs: "0.9rem", md: "1rem" },
                color: "#fff",
                background:
                  "linear-gradient(90deg, #19469b, #4f46e5)",
                "&:hover": {
                  opacity: 0.9,
                },
              }}
            >
              View All Experts
            </Button>
          </Box>
        )}
      </Container>
    </Box>
  );
};

export default HomeLegalExperts;